<template>
  <a-modal :closable="false" :confirm-loading="modalLoading" :maskClosable="false" :okButtonProps="{
            props: {
                disabled: !computedCanSubmit
            }
        }" :visible="enabled"
           cancelText="Anuluj" okText="Dodaj urządzenie" title="Dodanie urządzenia" @cancel="closeModal()" @ok="handleAddDevice">
    <strong style="display: block;">Nazwa urządzenia:</strong>
    <a-input v-model="form.name" :visibilityToggle="true" placeholder="Podaj nazwę..." style="margin-top: 8px;"
             type="text" @change="verifyDeviceName()">
      <a-icon #prefix style="color: rgba(0,0,0,.25)" type="desktop"/>
    </a-input>
    <small :style="'color: red; ' + (errors.name ? 'opacity: 1' : 'opacity: 0')">Nazwa nie może być pusta.</small>
    <div style="margin-top: 8px;">
      <strong style="display: block;">Wymagania:</strong>
      <small style="display: block;">
        <a-badge :status="form.name.length >= 3 ? 'success' : 'default'"/>
        Minimalnie 3
        znaki</small>
      <small style="display: block;">
        <a-badge :status="form.name.length <= 30 ? 'success' : 'default'"/>
        Maksymalnie 30
        znaków</small>
    </div>
  </a-modal>
</template>

<script>
import httpClient from '../../utils/httpClient';

export default {
  name: "AddDevice",
  props: {
    enabled: Boolean
  },
  data() {
    return {
      modalLoading: false,
      form: {
        name: ""
      },
      errors: {
        name: false
      }
    };
  },
  computed: {
    computedCanSubmit() {
      return this.form.name.length >= 3 && this.form.name.length <= 30
    }
  },
  methods: {
    handleAddDevice() {
      this.modalLoading = true
      httpClient.post("/devices", this.form).then((response) => {
        console.log(response)
        this.$message.success("Urządzenie zostało przypisane do konta")
        this.closeModal()
      }).catch((error) => {
        let message = error.response.data.message
        if (error.response && error.response.status === 400) {
          if (message.startsWith("Device already exists")) {
            this.$message.warning("Urządzenie istnieje już w systemie")
          }
        } else if (error.response && error.response.status === 401) {
          this.$message.error("Twoja sesja wygasła, zaloguj się ponownie")
          this.$router.push("/account/login")
        }
      }).finally(() => {
        this.modalLoading = false
      })
    },

    verifyDeviceName() {
      this.errors.name = this.form.name.length <= 0
    },

    closeModal() {
      this.form = {
        name: ""
      }
      this.$emit("close")
    }
  }
}
</script>